import { render, staticRenderFns } from "./ProductList4.vue?vue&type=template&id=8a83a85a&"
import script from "./ProductList4.vue?vue&type=script&lang=js&"
export * from "./ProductList4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports